import Icon from '../components/Icon.vue'

Icon.register({
  'shopping-bag': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M352 160V128C352 57.4 294.6 0 224 0 153.4 0 96 57.4 96 128V160H0V432C0 476.2 35.8 512 80 512H368C412.2 512 448 476.2 448 432V160H352zM160 128C160 92.7 188.7 64 224 64S288 92.7 288 128V160H160V128zM320 248C306.7 248 296 237.3 296 224S306.7 200 320 200 344 210.7 344 224 333.3 248 320 248zM128 248C114.7 248 104 237.3 104 224S114.7 200 128 200 152 210.7 152 224 141.3 248 128 248z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shopping-bag.js
// module id = 5i+G
// module chunks = 144